<template>
  <SAlert class="s-registration__failed" :color="color" size="lg">
    <div class="s-registration__failed__title">
      {{ tr(`company_registration_form.failed.${props.failedType}.title`) }}
    </div>

    <p
      class="s-registration__failed__text"
      v-html="tr(`company_registration_form.failed.${props.failedType}.text`)"
    />
  </SAlert>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { SAlert } from "@solvari/common-fe";
import { useI18nCompanyRegistrationForm } from "@solvari/translations";

const { tr } = useI18nCompanyRegistrationForm();

const props = defineProps<{ failedType: "emailExists" | "serverError" }>();

const color = computed(() => {
  if (props.failedType === "emailExists") {
    return "primary";
  }
  return "danger";
});
</script>

<style lang="postcss">
.s-registration__failed {
  @apply mb-6;

  &__title {
    @apply mb-4 font-secondary text-2xl font-bold;
  }

  &__text {
    @apply text-gray-800;
  }

  a {
    @apply text-primary-700 underline;
  }
}
</style>
